var _Path, _Rect, _Rect2, _Rect3, _Rect4, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Rect, Defs, ClipPath } from "react-native-svg";
var SvgTestTube = function SvgTestTube(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#testTube_svg__a)"
  }, /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#testTube_svg__b)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M36.641 0h-17.28c-2.254 0-4.088 1.759-4.088 3.922 0 1.398.767 2.627 1.92 3.321v38.389C17.192 51.348 22.04 56 28 56s10.81-4.652 10.81-10.368V7.243c1.15-.694 1.917-1.923 1.917-3.32C40.727 1.758 38.894 0 36.641 0m.228 7.836v37.796c0 4.697-3.97 8.506-8.869 8.506-4.897 0-8.867-3.809-8.867-8.506V7.33q.113.005.228.006h17.28q.114 0 .228-.006zm.784-2.099H18.347c-.675-.347-1.133-1.03-1.133-1.815 0-1.137.96-2.059 2.147-2.059h17.28c1.186 0 2.147.922 2.147 2.06 0 .785-.46 1.467-1.135 1.814"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M36.641 0h-17.28c-2.254 0-4.088 1.759-4.088 3.922 0 1.398.767 2.627 1.92 3.321v38.389C17.192 51.348 22.04 56 28 56s10.81-4.652 10.81-10.368V7.243c1.15-.694 1.917-1.923 1.917-3.32C40.727 1.758 38.894 0 36.641 0m.228 7.836v37.796c0 4.697-3.97 8.506-8.869 8.506-4.897 0-8.867-3.809-8.867-8.506V7.33q.113.005.228.006h17.28q.114 0 .228-.006zm.784-2.099H18.347c-.675-.347-1.133-1.03-1.133-1.815 0-1.137.96-2.059 2.147-2.059h17.28c1.186 0 2.147.922 2.147 2.06 0 .785-.46 1.467-1.135 1.814"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M21.251 27.048v18.584c0 3.569 3.028 6.475 6.75 6.475s6.75-2.906 6.75-6.475V26.919c-5.032 2.36-8.731-1.64-13.5.129"
  }), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 6.788,
    height: 11.879,
    y: 32.242,
    fill: "#FBD3C2",
    rx: 1
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    width: 6.788,
    height: 22.061,
    x: 8.485,
    y: 22.061,
    fill: "#FBD3C2",
    rx: 1
  })), _Rect3 || (_Rect3 = /*#__PURE__*/React.createElement(Rect, {
    width: 6.788,
    height: 22.061,
    x: 40.727,
    y: 22.061,
    fill: "#FBD3C2",
    rx: 1
  })), _Rect4 || (_Rect4 = /*#__PURE__*/React.createElement(Rect, {
    width: 6.788,
    height: 32.242,
    x: 49.212,
    y: 11.879,
    fill: "#FBD3C2",
    rx: 1
  })))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "testTube_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "testTube_svg__b"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
};
export default SvgTestTube;